// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--dc5ff"};